import React from 'react'

const TabNav = ({ tabs, active, onChange, isMobile }) => {
  return (
    <div className="flex items-center gap-6 dark:text-white/60 text-black/70">
      {tabs.map((t) => {
        const isActive = active === t
        return (
          <button
            key={t}
            onClick={() => onChange(t)}
            className={
              'relative pb-1 transition-colors' + (isMobile ? ' text-xs' : ' text-sm') +
              (isActive ? ' dark:text-white text-black' : ' dark:hover:text-white hover:text-black')
            }
          >
            {t}
            {isActive && (
              <span className="absolute left-0 -bottom-1 h-0.5 w-full bg-blue" />
            )}
          </button>
        )
      })}
    </div>
  )
}

export default TabNav

